export default "__VITE_ASSET__COStPh_k__"